var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { KeycloakService } from '../../services/keycloak.service';
import { CommonService, SFUN } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { ServiceException } from '../../model/exception';
import { FirmarComponent } from '../ingresocausa/firmar.component';
import { SIGNER_STATUS } from '../../common/firmador/firma-helper.component';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig, BUTTON_CLICK } from '../../common/dialog/mensaje.config';
import { WebSocketService } from '../../services/websocket.service';
import { SharedService } from '../../services/shared.service';
var IngresoMasivoComponent = (function () {
    function IngresoMasivoComponent(_service, _expService, _comService, _ws) {
        this._service = _service;
        this._expService = _expService;
        this._comService = _comService;
        this._ws = _ws;
        this.cargoExcel = false;
        this.imprimir = false;
        this.permiteNew = false;
        this.permiteCargarPlanilla = false;
        this.expSorteados = "";
        this.instancia = 0;
        this.tex_cod = "";
        this.cir = 0;
        this.cir_desc = "";
        this.fue = 0;
        this.org = 0;
        this.tex = { codigo: "", descr: "", forcar: "" };
        this.newCausa = { habil: false, concepto: null, tex: this.tex, nivel: 0, monto: "", cir_id: 0, cir_desc: "", observaciones: "", instancia: 0, caratula: "", usaRenaper: false, partes: [] };
        this.blockingFlag = -1;
        this.firmador = '';
        this.habDirecto = true;
        this.ingreso = false;
        this.permisoUsaRenaper = false;
        this.usarIMCWS = false;
        this.sessionId = "";
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    IngresoMasivoComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (typeof (KeycloakService.usr) !== 'undefined' && typeof (KeycloakService.usr.permisos) !== 'undefined') {
            this.permisoUsaRenaper = this._comService.tienePermiso(SFUN.ICMUsaRenaper);
        }
        this.validaPermiteCargar();
        this.habDirecto = this._comService.tienePermiso('IMSOR');
        this.usarIMCWS = this._comService.getConfiguracion('IMCASYNC') == 'true';
        this.hideErrorMsg();
        this.msgPopup.onClick.subscribe(function (event) { _this.onOkSussess(event); });
        this.msgPopupDoble.onClick.subscribe(function (event) { _this.onOKDoble(event); });
        this.mensajeConfigSource = new MensajeConfig('Ingreso Masivo de Causas');
        this.blockingFlag = 2;
        this._expService.findInstancias().subscribe(function (response) {
            _this.instList = response;
            _this.isPageLoaded();
        });
        // this._expService.findTiposExpediente().subscribe(response => {
        //     this.texList = response;
        //     this.isPageLoaded();
        // });
        this._service.findCir().subscribe(function (response) {
            _this.cirListOri = response;
            _this.recargarListas();
            _this.isPageLoaded();
        });
        this._service.findFue().subscribe(function (response) {
            _this.fueList = response;
            _this.isPageLoaded();
        });
        this.connectWS();
    };
    IngresoMasivoComponent.prototype.ngOnDestroy = function () {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
            //console.log("Desuscrito de los mensajes del WebSocket");
        }
        // Desconectar el WebSocket si es necesario
        //console.log("ngOnDestroy desconectar el WebSocket");
        this._ws.disconnect();
        this._ws = null;
    };
    IngresoMasivoComponent.prototype.connectWS = function () {
        var _this = this;
        // URL del WebSocket
        var wsUrl = SharedService.getProp("services_url")
            .replace("/api/", "/")
            .replace("http", "ws") + "manager-websocket";
        //console.log("url ws " + wsUrl);
        //console.log("Estableciendo conexion con el ws");
        this._ws.connect(wsUrl);
        this._ws.onOpen.subscribe(function () {
            //console.log("Conexión WebSocket establecida");
        });
        this.messageSubscription = this._ws.onMessage.subscribe(function (response) {
            //console.log("Mensaje recibido del ws: " + JSON.stringify(response));
            _this.processMessage(response);
        });
        // Manejar cierre de conexión (aún no se cierra)
        this._ws.onClose.subscribe(function () {
            //console.log("Conexión ws cerrada");
            _this._service.emitBlocking(false);
        });
        // Manejar errores del WebSocket
        this._ws.onError.subscribe(function (error) {
            //console.log("Error en ws");
            alert("Ha ocurrido un problema con el WebSocket");
            _this._ws.disconnect();
            _this._service.emitBlocking(false);
        });
    };
    IngresoMasivoComponent.prototype.onChangeSelectFue = function (selected) {
        var _this = this;
        this.fue = selected;
        this._expService.findTiposExpedienteByFue(selected).subscribe(function (response) {
            _this.texList = response;
            _this.isPageLoaded();
        });
        this.loadComboOrg();
    };
    IngresoMasivoComponent.prototype.isPageLoaded = function () {
        if (this.blockingFlag == 0) {
            this._service.emitBlocking(false);
        }
        else {
            this.blockingFlag = this.blockingFlag - 1;
        }
    };
    IngresoMasivoComponent.prototype.recargarListas = function () {
        var config_cir;
        if (!this.ingreso) {
            config_cir = 'SOR_EXCIR';
        }
        else {
            config_cir = 'DIR_EXCIR';
        }
        var cirConfiguradas = this._comService.getConfiguracion(config_cir);
        if (cirConfiguradas.length > 0) {
            this.cirList = this.deleteFromList(cirConfiguradas);
        }
        else {
            this.cirList = this.cirListOri;
        }
    };
    IngresoMasivoComponent.prototype.deleteFromList = function (cirConfiguradas) {
        var array = [];
        this.cirListOri.forEach(function (element) {
            if (cirConfiguradas.indexOf(element.id.toString()) < 0) {
                array.push(element);
            }
        });
        //console.log(array);
        return array;
    };
    IngresoMasivoComponent.prototype.onChangeSelectCir = function (selected) {
        this.selectCir(selected);
    };
    IngresoMasivoComponent.prototype.selectCir = function (selected) {
        this.cir = selected;
        var cirselect = this.cirList.find(function (item) { return item.id == selected; });
        this.cir_desc = cirselect.descr;
        this.loadComboOrg();
    };
    IngresoMasivoComponent.prototype.onChangeSelectInst = function (selected) {
        this.instancia = selected;
        this.loadComboOrg();
    };
    IngresoMasivoComponent.prototype.onChangeSelectTipo = function (selected) {
        var _this = this;
        this.tex_cod = selected;
        this._expService.findTipoExp(this.tex_cod).subscribe(function (response) {
            _this.tipoExp = response;
        });
    };
    IngresoMasivoComponent.prototype.onChangeFile = function (event) {
        //console.log("onChangeFile");
        this.archivo = [].slice.call(event.target.files);
        this.loadFile();
    };
    IngresoMasivoComponent.prototype.onCancel = function () {
        this.mensajeConfigSource = new MensajeConfig('Ingreso Masivo de Causas', true, 'Continuar');
        this.msgPopup.showMessage('Se perderan todos los datos cargados. ¿Esta seguro que desea cancelar la operación?');
    };
    IngresoMasivoComponent.prototype.onConfirmDoble = function () {
        this.mensajeConfigSource = new MensajeConfig('Posible Doble Inicialización', false, 'Continuar', true, 'Cancelar', true);
        this.msgPopupDoble.showMessage('Algunos expedientes presentan posible doble inicializacion ¿Esta seguro que desea continuar?');
    };
    IngresoMasivoComponent.prototype.onOKDoble = function (res) {
        //console.log('DOBLE resultado boton ' + res);
        if (BUTTON_CLICK.Continuar === res) {
            this.onFirmar();
        }
    };
    IngresoMasivoComponent.prototype.onAviso = function (sms, tit) {
        if (tit === void 0) { tit = "Ingreso Masivo de Causas"; }
        this.mensajeConfigSource = new MensajeConfig(tit, false, "", true, "Aceptar");
        this.msgPopup.showMessage(sms);
    };
    IngresoMasivoComponent.prototype.onConfirm = function () {
        this.hideErrorMsg();
        if (this.validateData()) {
            if (this.instancia == 3 && this.cir != 1) {
                this.onAviso(this._comService.getConfiguracion('AVISOINST'));
            }
            else {
                if (this._service.getCheckDoubleM()) {
                    if (this.existeDoble()) {
                        this.onConfirmDoble();
                    }
                    else {
                        this.onFirmar();
                    }
                }
                else {
                    this.onFirmar();
                }
            }
        }
    };
    IngresoMasivoComponent.prototype.existeDoble = function () {
        for (var i = 0; this.causas.length > i; i++) {
            if (this.causas[i].dobleIniciacion != null) {
                return true;
            }
        }
        return false;
    };
    IngresoMasivoComponent.prototype.noTienenConfiguracion = function () {
        for (var i = 0; this.causas.length > i; i++) {
            //console.log(this.causas[i]);
            if (this.causas[i].tieneConfig == null || this.causas[i].tieneConfig == 0) {
                this.onAviso("El concepto " + this.causas[i].ttr_descr + " no tiene configuracion");
                return true;
            }
        }
        return false;
    };
    IngresoMasivoComponent.prototype.validarTipoIngreso = function () {
        for (var i = 0; this.causas.length > i; i++) {
            //console.log(this.causas[i]);        
            if (this.ingreso) {
                if (this.causas[i].ttr_tipoIngreso != 2 && this.causas[i].ttr_tipoIngreso != 1) {
                    this.onAviso("El concepto " + this.causas[i].ttr_descr + " no corresponde a uno para ingreso directo");
                    return true;
                }
            }
            else {
                if (this.causas[i].ttr_tipoIngreso != 2 && this.causas[i].ttr_tipoIngreso != 0) {
                    this.onAviso("El concepto " + this.causas[i].ttr_descr + " no corresponde a uno que pueda sortearse");
                    return true;
                }
            }
        }
        return false;
    };
    IngresoMasivoComponent.prototype.validateErrorMaxCantFilas = function () {
        for (var i = 0; this.causas.length > i; i++) {
            //console.log(this.causas[i]);
            if (this.causas[i].errorMaxCantFilas == null || this.causas[i].errorMaxCantFilas) {
                this.onAviso(this.causas[i].errorMaxCantFilasDescr);
                return true;
            }
        }
        return false;
    };
    IngresoMasivoComponent.prototype.onFirmar = function () {
        var _this = this;
        this.msgPopup.onClick.subscribe(function (event) { _this.onOkSussess(event); });
        this.newCausa.cir_id = this.cir;
        this.newCausa.cir_desc = this.cir_desc;
        this.newCausa.instancia = this.instancia;
        this.newCausa.tex = this.tipoExp;
        if (this.ingreso) {
            this.newCausa.orgDestino = this.orgSelected;
            this.newCausa.secDestino = this.secretaria;
        }
        this.firmar.open(this.file.name, this.file.id, 'masivo');
        $('#firmar-' + this.instanceId).modal({
            backdrop: 'static',
            keyboard: false
        });
        $('#firmar-' + this.instanceId).modal('show');
    };
    IngresoMasivoComponent.prototype.validateData = function () {
        if (this.cir === 0) {
            this.showErrorMessage('Debe seleccionar la Circunscripción');
            return false;
        }
        if (this.instancia === 0) {
            this.showErrorMessage('Debe seleccionar la instancia');
            return false;
        }
        if (this.tex_cod === '') {
            this.showErrorMessage('Debe seleccionar un Tipo de Expediente');
            return false;
        }
        if (this.fue === 0) {
            this.showErrorMessage("Debe seleccionar el Fuero");
            return false;
        }
        if (this.ingreso && (this.orgSelected === undefined || this.orgSelected.orgId === null)) {
            this.showErrorMessage("Debe seleccionar el Organismo");
            return false;
        }
        if (this.ingreso) {
            if (this.noTienenConfiguracion()) {
                return false;
            }
        }
        if (this.validarTipoIngreso()) {
            return false;
        }
        if (this.validateErrorMaxCantFilas()) {
            return false;
        }
        if (this.ingreso && (this.tex_cod !== '' && this.tex_cod === 'INC')) {
            this.showErrorMessage("El tipo de expediente no puede ser INC");
            return false;
        }
        return true;
    };
    IngresoMasivoComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    IngresoMasivoComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = '';
        this.ErrorMessageIsVisible = false;
    };
    IngresoMasivoComponent.prototype.loadFile = function () {
        this._service.emitBlocking(true);
        var reader = new FileReader();
        var that = this;
        var fileName64 = that.archivo[0].name;
        fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
        //console.log("REMPALAZO NAME FILE " + that.archivo[0].name + " TO " + fileName64);
        var ext = fileName64.substring(fileName64.indexOf("."));
        //console.log("extension file " + ext);
        //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
        //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
        fileName64 = fileName64.substring(0, fileName64.indexOf(".")) + ext;
        reader.onloadend = function () {
            that._expService.uploadDocumento('masivo;' + fileName64, reader.result).subscribe(function (result) {
                that.file = result;
                that.readExcel(result);
            }, function (error) {
                var exc = ServiceException.parse(error.json());
                //console.log(exc.toString());
                alert(exc.description);
            });
        };
        if (that.archivo) {
            reader.readAsDataURL(that.archivo[0]);
        }
    };
    IngresoMasivoComponent.prototype.readExcel = function (fileId) {
        var _this = this;
        //console.log("readExcel");          
        //console.log(fileId.id, this.instancia, this.org);
        //console.log("permiso renaper", this.permisoUsaRenaper);
        this._expService.loadExcel(fileId.id, this.instancia, this.org, (this.ingreso) ? 1 : 0, this.cir, (this.permisoUsaRenaper) ? 'true' : 'false').subscribe(function (response) {
            // this.nuevoExp = response;
            _this.cargoExcel = true;
            _this.causas = response;
            _this._service.emitBlocking(false);
        }, function (error) {
            _this._service.emitBlocking(false);
            var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            alert(exc.description);
        });
    };
    IngresoMasivoComponent.prototype.modalArchivoEvent = function (event) {
        switch (event) {
            case SIGNER_STATUS.SIGNOK.code:
                if (this.usarIMCWS) {
                    //webSocket
                    //console.log("ingreso de causas por websocket");
                    this.insertMasivoThread();
                }
                else {
                    //console.log('demanda firmada!');
                    this.insertMasivo();
                }
                break;
            case SIGNER_STATUS.CLOSED.code:
                $('#firmar-' + this.instanceId).modal('hide');
                //console.log('modal firmar cerrado');
                break;
        }
    };
    IngresoMasivoComponent.prototype.insertMasivo = function () {
        var _this = this;
        this._service.emitBlocking(true);
        this.newCausa.firmador = this.firmador;
        this.newCausa.file = this.archivo;
        this.newCausa.usaRenaper = this.permisoUsaRenaper;
        //console.log("usa renaper para insert ", this.newCausa.usaRenaper);
        this._expService.insertMasivo(JSON.stringify(this.newCausa), this.file.id).subscribe(function (response) {
            _this.expSorteados = response.expsSorteados;
            //console.log('resultado ' + JSON.stringify(response));
            _this._service.emitBlocking(false);
            _this.onFinish(response.resultado);
            _this.imprimir = (_this.expSorteados !== '');
            _this.permiteNew = true;
        }, function (error) {
            //console.log('Error insert masivo ' + JSON.stringify(error));
            _this._service.emitBlocking(false);
            var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            alert(exc.description);
        });
    };
    IngresoMasivoComponent.prototype.processMessage = function (event) {
        //console.log("Mensaje recibido del ws: " + event.data);
        //console.log("Mensaje event " + JSON.stringify(event));
        var message = event.command;
        switch (message) {
            case 'init':
                //console.log("sessionId: " + event.data);
                this.sessionId = event.data;
                //console.log("sessionId: " + this.sessionId);
                break;
            case 'finIngresoMasivoThread':
                //console.log("Proceso ingreso masivo finalizado");
                this.getResultadosIngresoMasivo();
                break;
            case 'errorIngresoMasivoThread':
                //console.log("Error proceso ingreso masivo");
                this._service.emitBlocking(false);
                alert('Ocurrió un error en el proceso de ingreso masivo.');
                break;
            default:
        }
    };
    IngresoMasivoComponent.prototype.insertMasivoThread = function () {
        var _this = this;
        this._service.emitBlocking(true);
        this.newCausa.firmador = this.firmador;
        this.newCausa.file = this.archivo;
        this.newCausa.usaRenaper = this.permisoUsaRenaper;
        this._expService.insertMasivoThread(JSON.stringify(this.newCausa), this.file.id, this.sessionId).subscribe(function (response) {
            if (response) {
                //console.log("proceso de ingreso masivo iniciado");
            }
            else {
                //console.log("error proceso de ingreso masivo");
                _this._service.emitBlocking(false);
                alert("Error al iniciar el proceso de ingreso masivo");
            }
        }, function (error) {
            //console.log('Error insert masivo ' + JSON.stringify(error));
            _this._service.emitBlocking(false);
            //let exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            //alert(exc.description);
            alert("Error al iniciar el proceso de ingreso masivo");
        });
    };
    IngresoMasivoComponent.prototype.getResultadosIngresoMasivo = function () {
        var _this = this;
        this._expService.getResultadoInsertMasivoThread(this.file.id).subscribe(function (response) {
            _this.expSorteados = response.expsSorteados;
            //console.log('resultado ' + JSON.stringify(response));
            _this._service.emitBlocking(false);
            _this.onFinish(response.resultado);
            _this.imprimir = (_this.expSorteados !== '');
            _this.permiteNew = true;
        }, function (error) {
            //console.log('Error insert masivo ' + JSON.stringify(error));
            _this._service.emitBlocking(false);
            var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            alert(exc.description);
        });
    };
    IngresoMasivoComponent.prototype.selFirmador = function (event) {
        //console.log('firmador evento ' + event);
        this.firmador = event;
    };
    IngresoMasivoComponent.prototype.onFinish = function (sms) {
        this.mensajeConfigSource = new MensajeConfig("Ingreso Masivo de Causas", false, "", true, "Aceptar");
        if (sms != "" && sms != null) {
            this.msgPopup.showMessage(sms);
        }
        else {
            this.msgPopup.showMessage("El proceso finalizo con exito");
        }
    };
    IngresoMasivoComponent.prototype.onOkSussess = function (res) {
        //console.log("resultado boton " + res);
        if (BUTTON_CLICK.Aceptar === res) {
            this.onNew();
        }
    };
    IngresoMasivoComponent.prototype.onPrint = function () {
        var _this = this;
        this.hideErrorMsg();
        this._service.emitBlocking(true);
        var that = this;
        var fileName = "ingreso_masivo_causa.pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._expService.imprimirReporte(this.expSorteados, true, KeycloakService.getLoggedUser()).subscribe(function (response) {
            that._service.emitBlocking(false);
            var file = new Blob([response], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }, function (error) {
            that._service.emitBlocking(false);
            _this.showErrorMessage("No se pudo generar el Reporte");
        });
    };
    IngresoMasivoComponent.prototype.onNew = function () {
        this.hideErrorMsg();
        this.tex = { codigo: "", descr: "", forcar: "" };
        this.newCausa = { habil: false, concepto: null, tex: this.tex, nivel: 0, monto: "", cir_id: 0, cir_desc: "", observaciones: "", instancia: 0, caratula: "", usaRenaper: false, partes: [] };
        this.expSorteados = "";
        this.cargoExcel = false;
        this.imprimir = false;
        this.permiteNew = false;
        this.archivo = null;
        this.myInputVariable.nativeElement.value = "";
        this.causas = null;
        this.cir = 0;
        this.cir_desc = "";
        this.instancia = 0;
        this.tex_cod = "";
        this.fue = 0;
        this.org = 0;
        this.orgSelected = { orgId: null, descCorta: "", descripcion: "", dependencias: [], secretaria: null, depId: null, sedDepId: null, orgMultifuero: null };
        this.secretaria = { secId: null, descCorta: "", descripcion: "" };
        this.orgList = [];
        this.ingreso = true;
        this.validaPermiteCargar();
        this.recargarListas();
    };
    IngresoMasivoComponent.prototype.onClickDirecto = function (ev) {
        this.cir = 0;
        this.ingreso = !this.ingreso;
        if (!this.ingreso) {
            this.org = 0;
            this.orgSelected = { orgId: null, descCorta: "", descripcion: "", dependencias: [], secretaria: null, depId: null, sedDepId: null, orgMultifuero: null };
            this.secretaria = { secId: null, descCorta: "", descripcion: "" };
        }
        this.validaPermiteCargar();
        this.recargarListas();
    };
    IngresoMasivoComponent.prototype.validaPermiteCargar = function () {
        //console.log(this.orgSelected);
        if (this.ingreso) {
            if (this.orgSelected !== undefined && this.orgSelected.orgId !== null) {
                this.permiteCargarPlanilla = true;
            }
            else {
                this.permiteCargarPlanilla = false;
                this.causas = null;
                this.cargoExcel = false;
                this.archivo = null;
                this.myInputVariable.nativeElement.value = "";
            }
        }
        else {
            this.permiteCargarPlanilla = true;
        }
    };
    IngresoMasivoComponent.prototype.loadComboOrg = function () {
        var _this = this;
        if (this.fue != 0 && this.instancia != 0 && this.cir != 0) {
            this._comService.findOrgForIngreso(this.fue, this.instancia, this.cir).subscribe(function (response) {
                var list = response;
                if (list.length > 0) {
                    var permitidos = _this._comService.getConfiguracion('SOR_DIRORG');
                    var orgArray = permitidos.split(",");
                    _this.orgList = [];
                    var _loop_1 = function (i) {
                        org = list.find(function (item) { return item.orgId == +orgArray[i]; });
                        if (org !== undefined) {
                            _this.orgList.push(org);
                        }
                    };
                    var org;
                    for (var i = 0; orgArray.length > i; i++) {
                        _loop_1(i);
                    }
                    _this.secretaria = { secId: null, descCorta: "", descripcion: "" };
                }
            });
        }
    };
    IngresoMasivoComponent.prototype.onChangeSelectOrg = function (newValue) {
        if (newValue != 0) {
            //console.log(newValue);     
            this.orgSelected = this.orgList.find(function (item) { return item.orgId == newValue; });
            if (this.orgSelected !== undefined || this.orgSelected !== null) {
                this.secretaria = this.orgSelected.secretaria;
            }
        }
        else {
            this.orgSelected = { orgId: null, descCorta: "", descripcion: "", dependencias: [], secretaria: null, depId: null, sedDepId: null, orgMultifuero: null };
            this.secretaria = { secId: null, descCorta: "", descripcion: "" };
        }
        this.org = newValue;
        this.validaPermiteCargar();
    };
    return IngresoMasivoComponent;
}());
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], IngresoMasivoComponent.prototype, "msgPopup", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], IngresoMasivoComponent.prototype, "msgPopupDoble", void 0);
__decorate([
    ViewChild(FirmarComponent),
    __metadata("design:type", FirmarComponent)
], IngresoMasivoComponent.prototype, "firmar", void 0);
__decorate([
    ViewChild('myInput'),
    __metadata("design:type", Object)
], IngresoMasivoComponent.prototype, "myInputVariable", void 0);
IngresoMasivoComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'ingreso-masivo',
        templateUrl: 'ingreso-masivo.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, ExpedienteService, CommonService, WebSocketService])
], IngresoMasivoComponent);
export { IngresoMasivoComponent };
//# sourceMappingURL=ingreso-masivo.component.js.map